export const DEFAULT_IMG = "/images/star-league-logo.png";
export const DEFAULT_FEED_IMG = "/images/demo-feed.png";
export const IS_DISABLE_PWA = process.env.REACT_APP_IS_DISABLE_PWA || false;
export const chilizScan =
  process.env.REACT_APP_APP_ENV === "production"
    ? "https://chiliscan.com/tx"
    : "https://spicy-explorer.chiliz.com/tx";
// "https://chiliscan.com/tx";
